import _sfc_main from "./ManageMemberControl.vue2.mjs";
import "./ManageMemberControl.vue3.mjs";
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.manageMemberControlConfig.visible ? _c("div", { staticClass: "manage-member-control-container" }, [_c(_setup.IconButton, { attrs: { "is-active": _setup.sidebarName === "manage-member", "title": _setup.memberTitle, "icon": _setup.ManageMemberIcon }, on: { "click-icon": _setup.toggleMangeMemberSidebar } })], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "01765aa9"
);
const ManageMemberControl = __component__.exports;
export {
  ManageMemberControl as default
};
